import React from 'react';

function HotKeysRow({ actionName, keyboardName }) {
  return (
    <div className='cpt-key-row-container'>
      <div className='cpt-key-row-big'>
        <input type='text' readOnly className='cpt-hot-key-big-input' placeholder={actionName} />
      </div>
      <div className='cpt-key-row-small'>
        <input type='text' readOnly className='cpt-hot-key-big-input' placeholder={keyboardName} />
      </div>
    </div>
  );
}
export default HotKeysRow;
